import { cEl } from '../../../../util';
import { getPathVariables } from '../../../AppHeader/Link';
import { getSubmission } from '../../../../api/submission';
import { PATH_ADMIN_SUBMISSION_DETAIL } from '../../../path';
import { orderedTest, SCORE_KEY } from '../../Test/constants';
import ResultBox from '../../Test/StaticContents/TestResult/ResultBox';
import { ActionBox } from '../Submissions/SearchBox';

function Submission() {
    const submissionsContainer = cEl('div');
    submissionsContainer.classList.add('submission-container');
    const pathVariables = getPathVariables(PATH_ADMIN_SUBMISSION_DETAIL);

    if (pathVariables.submissionNum) {
        getSubmission(pathVariables).then(res => {
            submissionsContainer.innerHTML = '';

            const titleContainer = cEl('div');
            titleContainer.classList.add('title-container');

            const titleEl = cEl('div');
            titleEl.classList.add('title');
            titleEl.innerHTML = '문의하기';

            const subTitleEl = cEl('div');
            subTitleEl.classList.add('sub-title');
            subTitleEl.innerHTML = 'Inquiry';

            const prevButton = cEl('button');
            prevButton.classList.add('button', 'prev-button');
            prevButton.addEventListener('click', () => {
                window.history.back();
            });

            titleContainer.append(prevButton, subTitleEl, titleEl);

            submissionsContainer.append(titleContainer);
            if (res.data.name) {
                submissionsContainer.append(SubmissionDetail(res.data));
            }
            if (typeof res.data.readinessScore === 'number') {
                submissionsContainer.append(TestResult(res.data));
            }
            submissionsContainer.append(ActionBox({ rows: [res.data], submissionNum: res.data.submissionNum }));
        });
    }

    return submissionsContainer;
}

function SubmissionDetail(submission) {
    const detailContainer = cEl('div');
    detailContainer.classList.add('detail-container');
    detailContainer.append(
        DetailItem({ name: '이름', value: submission.name }),
        DetailItem({ name: '이메일 주소', value: submission.email }),
        DetailItem({ name: '휴대폰 번호', value: submission.phone }),
        DetailItem({ name: '소속 기관', value: submission.affiliation }),
        DetailItem({ name: '문의 내용', value: submission.message }),
    );
    return detailContainer;
}

function DetailItem({ name, value }) {
    const itemContainer = cEl('div');
    itemContainer.classList.add('detail-item');
    const title = cEl('span');
    title.innerText = name;
    title.classList.add('item-title');
    const contents = cEl('span');
    contents.innerText = value;
    contents.classList.add('item-contents');
    itemContainer.append(title, contents);
    return itemContainer;
}

function TestResult(testResult) {
    const resultContainer = cEl('div');
    resultContainer.classList.add('test-result-container');

    const scoredTest = [...orderedTest].filter(test => typeof test.conversionFactor === 'number');
    resultContainer.append(
        ...scoredTest.map(test => {
            const score = testResult[SCORE_KEY[test.key]];
            if (typeof score === 'number') {
                return ResultBox({ ...test, computedScore: score });
            }
            return ResultBox(test, true);
        }),
    );

    return resultContainer;
}

export default Submission;
